import { render } from "./PassengerDetails.vue?vue&type=template&id=e6af75f6&scoped=true&lang=pug"
import script from "./PassengerDetails.vue?vue&type=script&lang=ts"
export * from "./PassengerDetails.vue?vue&type=script&lang=ts"

import "./PassengerDetails.vue?vue&type=style&index=0&id=e6af75f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e6af75f6"

export default script